var _pattern, _rect, _rect2, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelecoms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1A237E",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0D47A1",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "signalGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2196F3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00BCD4",
      stopOpacity: 1
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "networkPattern",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 1,
    fill: "#FFFFFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 40,
    y2: 20,
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 40,
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    opacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#bgGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#networkPattern)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 125)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 48,
    letterSpacing: 3
  }, "\n        T\xC9L\xC9COMS\n      ")), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15,
    width: 320,
    height: 3,
    fill: "url(#signalGradient)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        IA g\xE9n\xE9rative\n      "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        Service client\n      ")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(295, 130)",
    stroke: "url(#signalGradient)",
    fill: "none",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,40 Q20,0 40,40",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,40 Q20,10 35,40",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,40 Q20,20 30,40",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2196F3",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 20,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 60,
    y2: 40,
    stroke: "#2196F3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 40,
    x2: 100,
    y2: 20,
    stroke: "#2196F3",
    strokeWidth: 1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 180)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L20,0 M25,0 L45,0 M50,0 L70,0",
    stroke: "#00BCD4",
    strokeWidth: 3,
    strokeDasharray: "20,5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10 L20,10 M25,10 L45,10 M50,10 L70,10",
    stroke: "#00BCD4",
    strokeWidth: 3,
    strokeDasharray: "20,5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecoms);
export default __webpack_public_path__ + "static/media/telecoms.7dfc77ada4529b27510a69454a309334.svg";
export { ForwardRef as ReactComponent };